module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_amazon-30d5e8aed6853a078ef28139b6721778.png";